import React, { useState, useMemo } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';

import { Empty } from 'antd';
import '@styles/AntStyles.css';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import {
  DivLoading,
  SpinnerLoadingMaterial,
  StyledTableCell,
  StyledTableCell2,
  StyledTableCell1,
  StyledTableCell3,
  StyledTableRow,
  useStyles,
  Container,
  DivVoid,
  StyledTableRow2,
} from './styles';
import { Box, Collapse, IconButton, Checkbox } from '@material-ui/core';

interface ITableProps {
  data: object[];
  columns: Object[];
  loading: Boolean;
  ActionHeader?: string;
  Actions?: IActionObj[];
  Selected?: Function;
  FieldsBold?: string[];
  keys: string[];
  selectedRows?: any[];
  onSelectRow?: (row: any) => void;
  onSelectAll?: (rows: any[]) => void;
}

interface IActionObj {
  Button: Function;
}

const TableColapse: React.FC<ITableProps> = ({
  data,
  columns,
  loading,
  Actions,
  ActionHeader,
  Selected,
  FieldsBold,
  keys,
  selectedRows,
  onSelectAll,
  onSelectRow,
}) => {
  const classes = useStyles();
  // const keys = Object.keys(data[0] || data);
  const alterColumns = columns[0] || {};

  // - ORDENAÇÃO -
  type SortConfig = {
    field: string;
    direction: 'asc' | 'desc';
  };

  const [sortConfig, setSortConfig] = useState<SortConfig>({
    field: '',
    direction: 'asc',
  });

  const handleSort = (field: string) => {
    setSortConfig(prev => {
      if (prev.field !== field) {
        return { field, direction: 'asc' };
      }

      return {
        field,
        direction: prev.direction === 'asc' ? 'desc' : 'asc',
      };
    });
  };

  const sortedData = useMemo(() => {
    if (!sortConfig.field) return data;

    return [...data].sort((a: any, b: any) => {
      const aVal = a[sortConfig.field];
      const bVal = b[sortConfig.field];

      let result = 0;

      if (typeof aVal === 'string') {
        result = aVal.localeCompare(bVal);
      }
      else {
        result = aVal - bVal;
      }

      if (result === 0) {
        result =
          new Date(a.Data).getTime() - new Date(b.Data).getTime();
      }

      return sortConfig.direction === 'asc' ? result : -result;
    });
  }, [data, sortConfig]);

  const Head = ({ keys, alterColumns }: any) => {
    return (
      <>
        {onSelectAll && (
          <StyledTableCell align="center">
            <Checkbox
              checked={selectedRows?.length === data.length && data.length > 0}
              indeterminate={
                selectedRows!.length > 0 &&
                selectedRows!.length < data.length
              }
              onChange={() => onSelectAll(data)}
            />
          </StyledTableCell>
        )}

        {keys.map((key: string) => (
          <StyledTableCell
            key={key}
            align="center"
            onClick={() => handleSort(key)}
            style={{ cursor: 'pointer' }}
          >
            {alterColumns[key] || key}

            {sortConfig.field === key && (
              sortConfig.direction === 'asc'

            )}
          </StyledTableCell>
        ))}

        {Actions && (
          <StyledTableCell align="center">
            {ActionHeader !== null ? ActionHeader : 'Opções'}
          </StyledTableCell>
        )}
      </>
    );
  };

  const Rows = ({ row }: any) => {
    const colunas = Object.keys(row);
    const [open, setOpen] = React.useState(false);

    return (
      <>
        <StyledTableRow>
          {onSelectRow && (
            <StyledTableCell align="center">
              <Checkbox
                checked={selectedRows?.some(r => r.IDSolicitacao === row.IDSolicitacao)}
                onChange={() => onSelectRow(row)}
              />
            </StyledTableCell>
          )}


          <StyledTableCell> {row.Data} </StyledTableCell>
          <StyledTableCell> {row.IDCadastro} </StyledTableCell>
          <StyledTableCell> {row.IDPerfil} </StyledTableCell>
          <StyledTableCell> <strong> {row.NomeCadastro}</strong> </StyledTableCell>
          <StyledTableCell> <strong> {row.Perfil} </strong></StyledTableCell>
          <StyledTableCell> {row.Campanha} </StyledTableCell>
          <StyledTableCell> {row.SolicitadoPor} </StyledTableCell>
          <StyledTableCell> {row.TipoSolicitacaoDescricao} </StyledTableCell>
          <StyledTableCell> {row.Banco} </StyledTableCell>
          <StyledTableCell1>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </StyledTableCell1>
        </StyledTableRow>
        <StyledTableRow>
          <StyledTableCell
            style={{ paddingBottom: 0, paddingTop: 0, padding: 0 }}
            colSpan={7}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Table className={classes.table}>
                <TableBody>
                  {row.Observacao.map((observacao: any) => (
                    <StyledTableRow2 key={observacao.coluna}>
                      <StyledTableCell2>{observacao.coluna}</StyledTableCell2>
                      <StyledTableCell3>{observacao.valor}</StyledTableCell3>
                    </StyledTableRow2>
                  ))}
                </TableBody>
              </Table>
            </Collapse>
          </StyledTableCell>
        </StyledTableRow>
      </>
    );
  };

  return (
    <Container>
      {loading && (
        <DivLoading>
          <SpinnerLoadingMaterial />
        </DivLoading>
      )}

      {loading && data.length <= 0 && (
        <DivVoid>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Nenhum dado encontrado"
          />
        </DivVoid>
      )}

      <TableContainer className={classes.container}>
        <Table className={classes.table} stickyHeader size="medium">
          {!loading && (
            <TableHead>
              <TableRow>
                <Head keys={keys} alterColumns={alterColumns} />
              </TableRow>
            </TableHead>
          )}

          <TableBody>
            {sortedData.map((row: any, index: number) => {
              return <Rows key={row.IDSolicitacao} row={row} />;
            })}
          </TableBody>
          <TableFooter></TableFooter>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default TableColapse;
